const e = "style-module__aiLawyerSelectorWrapper___-JA08", t = "style-module__aiLawyerIconContainer___hpYe-", _ = "style-module__aiLawyerIcon___IBr7B", o = "style-module__hoverEnabled___WmPcS", a = "style-module__popupOverlay___DFwB7", r = "style-module__aiLawyerPickerWrapper___hrhP5", l = "style-module__aiLawyerPickerItem___UGa1m", c = "style-module__aiLawyerPickerImage___rJDxh", y = "style-module__selectedLawyer___eWiG9", i = "style-module__topStart___CD12u", s = "style-module__topMiddle___wYpGy", d = "style-module__bottomStart___-2kUb", n = "style-module__bottomMiddle___3F1Jf", p = "style-module__noSelect___Oz9g3", m = {
  aiLawyerSelectorWrapper: e,
  aiLawyerIconContainer: t,
  aiLawyerIcon: _,
  hoverEnabled: o,
  popupOverlay: a,
  aiLawyerPickerWrapper: r,
  aiLawyerPickerItem: l,
  aiLawyerPickerImage: c,
  selectedLawyer: y,
  topStart: i,
  topMiddle: s,
  bottomStart: d,
  bottomMiddle: n,
  noSelect: p
};
export {
  _ as aiLawyerIcon,
  t as aiLawyerIconContainer,
  c as aiLawyerPickerImage,
  l as aiLawyerPickerItem,
  r as aiLawyerPickerWrapper,
  e as aiLawyerSelectorWrapper,
  n as bottomMiddle,
  d as bottomStart,
  m as default,
  o as hoverEnabled,
  p as noSelect,
  a as popupOverlay,
  y as selectedLawyer,
  s as topMiddle,
  i as topStart
};
